import isImageFeatherAllowed from 'editor/src/store/editor/selector/isImageFeatherAllowed';
import isImageMaskAllowed from 'editor/src/store/editor/selector/isImageMaskAllowed';

import { CanShow } from 'editor/src/component/Menu/type';

import ButtonImageMask from './ButtonImageMask';
import ButtonImageMaskDropDown from './ButtonImageMaskDropDown';

// GAPI-61890 / GAPI-61891: opt-in per host (shape and / or soft edge); in the embedded editor only when the template
// allows adding layers (see isImageMaskAllowed / isImageFeatherAllowed). Also offered on empty frames so template authors can shape placeholders
export const canShow: CanShow = (state, { selectedElementType, isPersonalizationLocked, isSelectionLocked }) =>
  (isImageMaskAllowed(state) || isImageFeatherAllowed(state)) &&
  selectedElementType === 'image' &&
  !isPersonalizationLocked &&
  !isSelectionLocked;

export { ButtonImageMask, ButtonImageMaskDropDown };

export default ButtonImageMask;
